import { createSelector } from 'reselect';

export const ticketOutSelector = createSelector(
  (state) => state && state.ticketOut && state.ticketOut.ticketOut,
  (ticketOutSelector) => ticketOutSelector
);

export const transactionSelector = createSelector(
  (state) => state && state.ticketOut && state.ticketOut.transactions,
  (transactionSelector) => transactionSelector
);

export const PDFpreviewReadySelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.storePDFPreviewReady,
  (PDFpreviewReadySelector) => PDFpreviewReadySelector
);
export const rollOverRequestsSelector = createSelector(
  (state) => state && state.ticketOut && state.ticketOut.rollOverRequests,
  (rollOverRequestsSelector) => rollOverRequestsSelector
);
export const PointPDFpreviewReadySelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.storePointPDFPreviewReady,
  (PointPDFpreviewReadySelector) => PointPDFpreviewReadySelector
);
export const matchPointPDFpreviewReadySelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.storeMatchPointPDFPreviewReady,
  (matchPointPDFpreviewReadySelector) => matchPointPDFpreviewReadySelector
);
export const masterReadingPDFpreviewReadySelector = createSelector(
  (state) =>
    state.ticketOut && state.ticketOut.storeMasterReadingPDFPreviewReady,
  (masterReadingPDFpreviewReadySelector) => masterReadingPDFpreviewReadySelector
);
export const refreshSelector = createSelector(
  (state) => state.global && state.global.refresh,
  (refreshSelector) => refreshSelector
);
export const globalPDFPreviewReadySelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.storeGlobalPDFPreviewReady,
  (globalPDFPreviewReadySelector) => globalPDFPreviewReadySelector
);

export const reportPhotosSelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.reportPhotos,
  (reportPhotosSelector) => reportPhotosSelector
);

export const ticketPhotoSettingSelector = createSelector(
  (state) => state.ticketOut && state.ticketOut.ticketPhotoSetting,
  (ticketPhotoSettingSelector) => ticketPhotoSettingSelector
);
export const blacklistAlertSelector = createSelector(
  (state) => state.global && state.global.blacklistAlert,
  (blacklistAlertSelector) => blacklistAlertSelector
);
